// Card descriptions, recommendation map, and modal copy for the
// Account Classification add-level flow. Card keys map to entries in
// `decisionTypes['Account Classification']` (see ./data) so the
// lookup into filterItems is by-label, matching the BE/Principles
// flows.
//
// 'class-elements' is intentionally excluded — it's the auto-created
// Level 1 and not user-selectable.

export const classificationDecisionTypeCards = [
  {
    key: 'class-default',
    title: 'Accounts',
    description: [
      { text: 'In this level, students will sort accounts to their correct financial statement elements (Assets, Liabilities, Equity, Revenues, Expenses).' },
    ],
  },
  {
    key: 'class-tricky',
    title: 'Deferral & Contra Accounts',
    description: [
      { text: 'In this level, students will sort common deferral and contra accounts to their correct financial statement element.' },
    ],
  },
  {
    key: 'classified-multistep',
    title: 'Classified & Multistep',
    description: [
      { text: 'In this level, students sort accounts into the correct sections of the classified balance sheet and multistep income statement.' },
    ],
  },
  {
    key: 'real-public-co',
    title: 'Real Companies',
    description: [
      { text: 'In this level, students sort real company accounts into the correct sections of the classified balance sheet and multistep income statement.' },
    ],
  },
];

// No level-specific recommendation by default. Add an entry here
// (e.g. { 2: 'class-default' }) if a particular level should surface
// a card as recommended.
export const classificationRecommendedByLevel = {};

export const classificationModalCopy = {
  title: (levelNumber) => `Level ${levelNumber} | Select Decision Type`,
  subtitle: 'In each level, students sort items to their applicable financial statement category.',
  step2Title: (levelNumber) => `Level ${levelNumber} | Select Scenario & Accounts`,
  step2Subtitle: 'Select a scenario and related accounts',
  scenariosColumnHeader: 'Scenarios',
  transactionsColumnHeader: 'Transactions',
  accountsColumnHeader: 'Accounts',
  changeDecisionTypeButton: 'Change Decision Type',
  saveButton: 'Save',
  recommendedBadge: ['Recommended', 'for this Level'],
  switchScenarioWarningTitle: 'Are you sure?',
  switchScenarioWarningText: 'Selecting a transaction from a different business scenario will override your existing selections. You cannot mix transactions from different business scenarios in one level.',
};

// Card colors per the Classification spec. Background + stroke are
// inlined as CSS variable overrides on the modal root. Title text and
// divider follow the BE pattern (navy text, divider matching border).
export const classificationTheme = {
  '--be-card-bg': '#FAEDED',
  '--be-card-border': '#A98DF6',
  '--be-card-divider': '#A98DF6',
  '--be-card-text': '#2A4169',
};
